import {Skeleton} from '@/shared/ui/components/skeleton';

/** Pending calendar: the header bar and a grid-shaped block, full width like the page. */
export const CalendarSkeleton = () => (
  <div className="flex min-w-0 flex-col lg:h-full" aria-busy="true">
    <div className="flex flex-none items-center justify-between gap-3 border-b px-4 py-3 sm:px-6 sm:py-4">
      <Skeleton className="h-6 w-40" />
      <div className="flex items-center gap-4">
        <Skeleton className="h-8 w-24 md:w-40" />
        <Skeleton className="hidden h-8 w-64 md:block" />
      </div>
    </div>
    <Skeleton className="m-4 h-96 rounded-lg sm:m-6 lg:flex-auto" />
  </div>
);
